module.exports = __webpack_public_path__ + "static/media/cert_5245.b6707e65.jpg";